<template>
  <Loading />

  <section
    class="min-h-screen flex flex-col md:flex-row bg-black text-white font-berthold-force"
  >
    <!-- Esquerda: login -->
    <div
      class="md:w-1/2 w-full flex flex-col justify-center items-center px-6 py-10 z-10"
    >
      <div class="max-w-md w-full space-y-6">
        <!-- Título -->
        <div class="flex justify-between items-center mb-16">
          <h1 class="text-3xl font-bold uppercase">Entrar</h1>
          <a href="/signin">
            <img
              :src="appLogo"
              alt="Logo"
              class="h-10"
            />
          </a>
        </div>

        <!-- Botão login Google -->
        <button
          @click="loginWithGoogle"
          class="text-2xl tracking-wide transition-all hover:scale-105 w-full flex items-center justify-center gap-3 px-4 py-3 rounded-sm bg-white text-black font-semibold border border-gray-300 mt-auto mb-auto"
        >
          <img
            src="https://www.svgrepo.com/show/475656/google-color.svg"
            alt="Google logo"
            class="w-7 h-7"
          />
          Entrar com Google
        </button>

        <!-- Divisor -->
        <div class="flex items-center gap-4 text-gray-400 text-sm lowercase">
          <div class="flex-1 h-px bg-gray-600"></div>
          Ou
          <div class="flex-1 h-px bg-gray-600"></div>
        </div>

        <Transition mode="out-in">
          <div :key="componentActive">
            <keep-alive>
              <component :is="componentActive"></component>
            </keep-alive>
          </div>
        </Transition>

        <div class="flex items-center gap-4 text-gray-400 text-sm lowercase">
          <div class="flex-1 h-px bg-gray-600"></div>
          {{
            label.__name == 'SignIn'
            ? 'Não tem uma conta?'
            : 'Já é cadastrado?'
          }}
          <div class="flex-1 h-px bg-gray-600"></div>
        </div>

        <button
          type="submit"
          class="w-full py-3 bg-white text-red-700 font-bold uppercase hover:bg-red-800 hover:text-white transition"
          @click="setComponentActive()"
        >
          {{
            label.__name == 'SignIn'
            ? 'Cadastre-se'
            : 'Faça login'
          }}
        </button>

      </div>
    </div>

    <!-- banner -->
    <div class="relative md:w-1/2 w-full hidden md:block">
      <img
        :src="banner"
        class="h-full max-h-[100vh] w-full object-cover"
        alt="banner"
      />
      <div
        class="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-transparent"
      ></div>
    </div>
  </section>
</template>

<script setup>
import router from '@/router'
import SharedService from '@/shared/services/shared'
import { dataShared } from '@/shared/store'
import { parseJwt } from '@/utils/customers/bearer'
import { computed, onBeforeMount, onMounted, markRaw } from 'vue'
import { useRoute } from 'vue-router'
import SignUp from './components/SignUp.vue'
import SignIn from './components/SignIn.vue'
import Loading from '@/shared/components/Loading.vue'
import { showToast as toast } from '@/helpers/UseToasts'
import { ref } from 'vue'
import Events from '../authenticated/events.vue'
import defaultLogo from '@/assets/logo/logo-rs.png'

// const appLogo = computed(() => dataShared.getters.getAppLogo)
const componentActive = computed(() => dataShared.getters.getActiveComponentLogin)
const label = computed(() => dataShared.state.activeComponentLogin)
const uri = process.env.VUE_APP_BASE_API_URL
const route = useRoute()
const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
const defaultBanner = require('@/assets/logo/banner-login.png')
const auth = computed(() => dataShared.getters.getDataByUserLogged)
const banner = computed(() => {
  if (dataShared.getters.bannerLogin !== null) { return fileUrl + dataShared.getters.bannerLogin }

  return defaultBanner
})

const appLogo = computed(() => {
  return dataShared.getters.getLogo || defaultLogo
})

function loginWithGoogle () {
  const raw = dataShared.getters.getRedirectFighterCoupon
  const redirect = (typeof raw === 'string' && raw.startsWith('/')) ? raw : '/events'

  dataShared.dispatch("setRedirectFighterCoupon", null)

  window.location.href = `${uri}auth/google?redirect=${encodeURIComponent(redirect)}`
}

function setComponentActive () {
  if (label.value.__name == 'SignIn') {
    dataShared.dispatch('setComponentActiveLogin', markRaw(SignUp))
  } else { dataShared.dispatch('setComponentActiveLogin', markRaw(SignIn)) }
}

async function getLoginBanner () {
  await SharedService.getBannerLogin()
    .then((res) => {
      dataShared.dispatch('setBannerLogin', res.data?.loginBanner)
    })
    .catch((err) => {
      console.log(err)
    })
}

onBeforeMount(async () => {
  dataShared.dispatch('getLogo')
  dataShared.dispatch('activeLoading')

  Promise.all([
    getLoginBanner()
  ])

  if (route.query.error == 'socialite_failure' || route.query.error == 'unauthenticated') {
    dataShared.dispatch('setComponentActiveLogin', markRaw(SignIn))

    // localStorage.clear()
  
    toast(
      'Aviso',
      'Sessão expirada',
      'error'
    )

    router.replace('/auth')
  }

  dataShared.dispatch('desactiveLoading')
})
</script>

<style scoped lang="scss">
@media (max-width: 1024px) {
  section {
    flex-direction: column;
  }
}

.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}

</style>
